import React from 'react';
import { Link } from 'react-router-dom';

const quickActions = [
  {
    title: 'Main',
    description: '대시보드로 돌아가기',
    to: '/',
  },
  {
    title: 'Sign Up',
    description: 'Bitget 계정 빠르게 연결',
    to: '/SignupAts',
  },
  {
    title: 'Log In',
    description: '로그인 후 전략 이어가기',
    to: '/LoginAts',
  },
  {
    title: 'Auto Trade',
    description: '세부 전략 옵션 선택',
    to: '/SelectPage',
  },
];

const highlights = [
  '20+ 프리셋 전략을 원클릭으로 활성화',
  'Funding / Volatility 필터 자동 적용',
  '익절·헷지 시나리오 실시간 전환',
];

const SelectBitget = () => {
    return (
    <div className="exchange-landing exchange-landing--bitget">
      <span className="exchange-landing__overlay" />

      <div className="exchange-landing__content exchange-landing__content--single">
        <section className="exchange-landing__hero">
          <p className="exchange-badge">Bitget Suite</p>
          <h1>
            Bitget 자동매매 허브<br />
            전략 · 주문 · 제어까지 한 번에.
          </h1>
          <p className="exchange-hero__subtitle">
            Bitgenstone이 설계한 비트겟 전용 전략을 선택하고, 조건부 진입부터 리스크 관리까지 한 화면에서 제어하세요.
          </p>

          <ul className="exchange-highlight-list">
            {highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="exchange-actions">
            {quickActions.map((action) => (
              <Link to={action.to} className="exchange-action-card" key={action.title}>
                <div>
                  <p className="exchange-action__title">{action.title}</p>
                  <p className="exchange-action__desc">{action.description}</p>
                </div>
                <span aria-hidden="true">→</span>
              </Link>
            ))}
          </div>

          <p className="exchange-hero__hint">
            신규 가입자는 추천 셋팅값을 확인하세요.
          </p>
        </section>

        {/* <section className="exchange-landing__panel">
          <div className="exchange-panel-card">
            <p className="exchange-panel__label">Bitget Essentials</p>
            <h3>모바일·데스크톱 상시 동기화</h3>
            <p className="exchange-panel__subtitle">
              프로그램 현황, 지정 심볼 목록등 모든 요소를 디바이스에 맞게 자동 재배치합니다.
            </p>

            <div className="exchange-panel__stats">
              <article>
                <span className="stat-label">지원 레버리지</span>
                <strong>1x ~ 125x</strong>
              </article>
              <article>
                <span className="stat-label">자동 전략</span>
                <strong>24 Set</strong>
              </article>
              <article>
                <span className="stat-label">실시간 알림</span>
                <strong>Web & Push</strong>
              </article>
            </div>

            <div className="exchange-panel__footer">
              <div>
                <p className="exchange-panel__mini">추천 시나리오</p>
                <p className="exchange-panel__mini-desc">Hedge · Kinpoint · Circle</p>
              </div>
              <div className="exchange-panel__tags">
                <span>Bitget</span>
                <span>USDT-M</span>
                <span>Copy</span>
              </div>
            </div>
          </div>
        </section> */}
            </div>
        </div>
    );
};

export default SelectBitget;